import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

import BannerBackground from '../../common/BannerBackground';
import CtaLink from '../../common/ui/CtaLink';

const Banner = (props) => {
  const { title, label, icon, subtitle, image } = props;

  const Icon = icon;

  return (
    <BannerBackground>
      <Wrapper>
        <ContentWrapper>
          <Label>
            <Icon /> {label}
          </Label>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
          {label !== 'Payments' && (
            <CtaLink color="var(--orange)" to="/demo">
              Schedule a demo
            </CtaLink>
          )}
        </ContentWrapper>
        <ImageWrapper>
          <GatsbyImage
            image={image.childImageSharp.gatsbyImageData}
            alt="A screenshot of Commerce7 platform."
          />
        </ImageWrapper>
      </Wrapper>
    </BannerBackground>
  );
};

const Wrapper = styled.div`
  ${({ theme }) => `
  @media ${theme.xLargeUp} {
      display: flex;
      align-items: center;
    }
  `}
`;

const ContentWrapper = styled.div`
  margin-bottom: 60px;
  ${({ theme }) => `
    @media ${theme.xLargeUp} {
      margin-bottom: 0px;
      width: 50%;
    }
  `}
`;

const ImageWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin: auto;
  ${({ theme }) => `
  @media ${theme.xLargeUp} {
      margin: 0;
      width: 50%;
    }
  `}
`;

const Label = styled.h4`
  font-size: var(--heading-size-xs);
  color: rgba(255, 255, 255, 0.8);

  display: flex;
  align-items: center;
  margin-bottom: 15px;
  svg {
    margin-right: 5px;
    margin-top: -1px;
    height: 20px;
    path {
      fill: rgba(255, 255, 255, 0.8);
    }
  }
`;

const Title = styled.h1`
  color: var(--white);
  line-height: var(--line-height-sm);
  font-size: var(--heading-size-xl);
  font-weight: var(--font-weight-black);
  margin: 10px 0 40px;

  ${({ theme }) => `
  @media ${theme.mediumUp} {
    font-size: var(--heading-size-2xl);
    line-height: var(--line-height-sm);
  }
  `}
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.75);
  margin-bottom: 40px;
`;

export default Banner;
